import { render, staticRenderFns } from "./TeacherSignIn.vue?vue&type=template&id=0271f8a2&scoped=true"
import script from "./TeacherSignIn.vue?vue&type=script&lang=js"
export * from "./TeacherSignIn.vue?vue&type=script&lang=js"
import style0 from "./TeacherSignIn.vue?vue&type=style&index=0&id=0271f8a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0271f8a2",
  null
  
)

export default component.exports